import React from 'react'
import telephone_icon from '../images/telephone-call.png'
import burger_icon from '../images/burger-bar.png'
import '../CSS/Navbar.css'
import Modalbox from './Modalbox'
function Navbar() {
  // window.addEventListener('scroll',(event)=>{
  //   let navbar=document.getElementById('navbar__container');
  //   navbar.style.background='white';
  //   navbar.style.borderBottom='1px solid lightgray';
  //   // navbar.style.zIndex='100';
  // })
  return (
   <div  id="navbar__container" className="navbar__container flex items-center  bg-[#f5df4e] pr-4 pl-4 md:pr-[70px] md:pl-[70px] pt-[15px] pb-[15px] ">
       <h1 className='flex-1 '>IBTISAM</h1>
       <div className='flex items-center md:pl-[40px] md:pr-[40px]'>
           <img src={telephone_icon}  alt='call' width={30} className='telephone__icon mr-4 ml-4'/>
           <label>0316 4431866</label>

       </div>
       <img src={burger_icon} alt='burger_icon' className='cursor-pointer hidden md:inline-block' width={35} 
      />

   </div>
  )
}

export default Navbar